import { render, staticRenderFns } from "./actions-panel.vue?vue&type=template&id=230652f8&"
import script from "./actions-panel.vue?vue&type=script&lang=js&"
export * from "./actions-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports